import { StateFilterData } from '../forms/address/types';
import { IViewItemAnalytics } from '../analytics/types';
import LevelFirstForm from './LevelFirstForm';
import AnalyticsService from '../analytics/AnalyticsService';

interface PageConfig {
  stateFilterData: StateFilterData;
  viewItemAnalytics: IViewItemAnalytics;
  membershipPrice: number;
}

window.tnew.page.initialize = function initialize({ stateFilterData, viewItemAnalytics, membershipPrice }: PageConfig) {
  if (viewItemAnalytics) {
    AnalyticsService.trackViewItem(viewItemAnalytics);
    AnalyticsService.pushEcommerceItems(viewItemAnalytics.items);
  }

  const $form = document.querySelector('#tn-level-first-form') as HTMLFormElement;

  new LevelFirstForm($form, stateFilterData, viewItemAnalytics, membershipPrice);
};
